const complianceNoteText =
  "Based on the difference between the lowest and highest annuity rate a Pense customer received in March 2026.";

export function ComplianceNote() {
  return <p className="lv2-compliance-note">{complianceNoteText}</p>;
}
